export default {
  generateCredentials(registrations) {
    function slugify (str) {
      var map = {
        'a' : 'á|à|ã|â|ä|À|Á|Ã|Â|Ä',
        'e' : 'é|è|ê|ë|É|È|Ê|Ë',
        'i' : 'í|ì|î|ï|Í|Ì|Î|Ï',
        'o' : 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
        'u' : 'ú|ù|û|ü|Ú|Ù|Û|Ü',
        'c' : 'ç|Ç',
        'n' : 'ñ|Ñ'
      };
      
      for (var pattern in map) {
        str = str.replace(new RegExp(map[pattern], 'g'), pattern);
      }

      return str;
    }

    function generateUsername(element) {
      console.log(element);
      let firstnames = element.firstname.split(' ');
      let shortFirstname = '';
      firstnames.forEach(firstname => {
        shortFirstname += firstname.charAt(0);
      });

      let dates = element.birthdate.split('-');
      let shortDate = (dates.length == 3)? dates[1] + dates[2] : ''; 

      // let username = ( 
      //   shortFirstname +
      //   ((element.middlename)? element.middlename.charAt(0) : '') +
      //   element.lastname).toLowerCase().replace(/\s/g,'');

      let username = (shortFirstname + element.lastname + shortDate).toLowerCase().replace(/\s/g,'');
      return slugify(username);
    }

    return registrations.map(element => ({
      lastname: element.lastname,
        firstname: element.firstname,
        middlename: element.middlename,
        email: element.email,
        phone1: element.mobile,
        address: element.city + ', ' + element.barangay + ', ' + element.street,
        username: generateUsername(element),
        // password: generateUsername(element) + (element.mobile).substr(element.mobile.length - 4),
        password: generateUsername(element),
      })
    );
  }
}